import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    base: "flex justify-center items-center h-[156px] border border-dashed border-primary-300 dark:border-primary-600 bg-fx-neutral-900 dark:bg-fx-neutral-800 rounded-[8px] py-4 px-4 gap-10 cursor-pointer transition",
    grayTextsBlue: "!text-fx-primary-400",
    grayTextsLight: "!text-fx-neutral-100",
    grayTextsMedium: "!text-fx-neutral-400",
    grayTextsCenter: "!text-fx-neutral-400 block text-center",

    previewWrapper: "text-neutral-400",
    previewBox:
      "relative flex items-center w-[269px] h-[69px] rounded-[4px] border-2 border-fx-neutral-600 bg-fx-neutral-900 overflow-hidden",
    imagePreview: "relative w-full object-cover",
    previewLogo: "relative w-[270px] h-[70px] mb-5 overflow-hidden",

    contentWrapper: "flex items-center justify-between gap-12",
    content: "flex flex-col",
    uploadArea: "flex gap-5",

    actionWrapper: "flex flex-col items-center",
    actionWrapperWithImg: "flex flex-col items-center w-full",
    actionGroup: "flex justify-center gap-4",
    actionButtons:
      "border-primary-300 text-primary-300 hover:border-primary-300 hover:text-primary-300 dark:border-primary-600 dark:text-primary-600 dark:hover:border-primary-600 dark:hover:text-primary-600",
    actionIcons: "w-6 h-6",
  },
  variants: {
    hasPreview: {
      true: {
        previewBox: "border-1.5",
        base: "border-none cursor-auto bg-[#1F1F1F]",
      },
    },
  },
});
